import { IFinancialsInfo } from "financials/models";
import { http } from "shared/api/http";

const buildFinancialsPath = (tenantId: string, organizationId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants/${tenantId}/organizations/${organizationId}/financials`;

export const getFinancialsInfo = async (tenantId: string, organizationId: string) => {
  if (!tenantId || !organizationId) {
    throw new Error("tenantId and organizationId are required to fetch financials info");
  }

  const res = await http.get<IFinancialsInfo>(
    `${buildFinancialsPath(tenantId, organizationId)}/info`
  );
  return res?.data;
};
